<template>
  <main class="login-screen">
    <section class="login-shell">
      <div class="login-header">
        <div class="brand-row">
          <div class="brand-mark">
            <img src="/img/boarua-icon-concept-v1.png" alt="" />
          </div>
          <div>
            <h1>BOARUA</h1>
            <p>App do morador</p>
          </div>
        </div>

        <div class="welcome-copy">
          <strong>{{ isSignup ? "Crie sua conta" : "Acesse seu local" }}</strong>
          <p>{{ isSignup ? "Cadastre seu acesso e aceite convites quando forem enviados pela associação." : "Entre com seu celular ou use uma conta social quando a integração estiver ativa." }}</p>
        </div>
      </div>

      <div class="login-panel">
        <div class="mode-switch" role="tablist" aria-label="Acesso">
          <button :class="{ active: mode === 'login' }" type="button" @click="setMode('login')">Entrar</button>
          <button :class="{ active: mode === 'signup' }" type="button" @click="setMode('signup')">Criar conta</button>
        </div>

        <v-form v-if="mode === 'login'" ref="form" v-model="loginForm.validForm" lazy-validation @submit.prevent="login">
          <h2>Entrar</h2>

          <div class="field-label">
            <v-icon small color="#267062">mdi-cellphone</v-icon>
            <span>Celular</span>
          </div>
          <v-text-field
            ref="phone"
            v-mask="'(##) #####-####'"
            v-model="loginForm.user.phone"
            :rules="[$rules.required]"
            autocomplete="tel"
            inputmode="tel"
            maxlength="15"
            placeholder="(11) 99999-9999"
            outlined
            type="tel"
            class="login-field"
          />

          <div class="field-label">
            <v-icon small color="#267062">mdi-lock-outline</v-icon>
            <span>Senha</span>
          </div>
          <v-text-field
            id="password"
            v-model="loginForm.user.password"
            :append-icon="loginForm.showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
            :rules="[$rules.required]"
            :type="loginForm.showPassword ? 'text' : 'password'"
            autocomplete="current-password"
            outlined
            hide-details="auto"
            class="login-field"
            @click:append="loginForm.showPassword = !loginForm.showPassword"
          />

          <v-btn block depressed color="primary" class="login-button" :loading="loginForm.loading" type="submit">
            Entrar
            <v-icon right small>mdi-arrow-right</v-icon>
          </v-btn>

          <div class="social-divider"><span>ou continue com</span></div>

          <div class="social-actions">
            <button class="social-button" type="button" disabled>
              <v-icon size="18">mdi-google</v-icon>
              Google
            </button>
            <button class="social-button" type="button" disabled>
              <v-icon size="20">mdi-apple</v-icon>
              Apple
            </button>
          </div>

          <div class="login-links">
            <span>
              <v-icon x-small color="#267062">mdi-shield-check-outline</v-icon>
              Convite obrigatório
            </span>
            <button type="button" @click="setMode('signup')">Criar conta</button>
          </div>
        </v-form>

        <v-form v-else ref="signupFormRef" v-model="signupForm.validForm" lazy-validation @submit.prevent="signup">
          <h2>Criar conta</h2>

          <div class="field-label">
            <v-icon small color="#267062">mdi-account-outline</v-icon>
            <span>Nome</span>
          </div>
          <v-text-field
            v-model="signupForm.user.name"
            :rules="[$rules.required]"
            autocomplete="name"
            outlined
            hide-details="auto"
            class="login-field"
          />

          <div class="field-label">
            <v-icon small color="#267062">mdi-cellphone</v-icon>
            <span>Celular</span>
          </div>
          <v-text-field
            v-mask="'(##) #####-####'"
            v-model="signupForm.user.phone"
            :rules="[$rules.required]"
            autocomplete="tel"
            inputmode="tel"
            maxlength="15"
            outlined
            type="tel"
            class="login-field"
          />

          <div class="field-label">
            <v-icon small color="#267062">mdi-email-outline</v-icon>
            <span>E-mail</span>
          </div>
          <v-text-field
            v-model="signupForm.user.email"
            :rules="[$rules.required, $rules.email]"
            autocomplete="email"
            outlined
            hide-details="auto"
            class="login-field"
          />

          <div class="field-label">
            <v-icon small color="#267062">mdi-lock-outline</v-icon>
            <span>Senha</span>
          </div>
          <v-text-field
            v-model="signupForm.user.password"
            :append-icon="signupForm.showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
            :rules="[$rules.required, minPassword]"
            :type="signupForm.showPassword ? 'text' : 'password'"
            autocomplete="new-password"
            outlined
            hide-details="auto"
            class="login-field"
            @click:append="signupForm.showPassword = !signupForm.showPassword"
          />

          <div class="field-label">
            <v-icon small color="#267062">mdi-lock-check-outline</v-icon>
            <span>Confirmar senha</span>
          </div>
          <v-text-field
            v-model="signupForm.user.passwordConfirmation"
            :append-icon="signupForm.showConfirmPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
            :rules="[$rules.required, samePassword]"
            :type="signupForm.showConfirmPassword ? 'text' : 'password'"
            autocomplete="new-password"
            outlined
            hide-details="auto"
            class="login-field"
            @click:append="signupForm.showConfirmPassword = !signupForm.showConfirmPassword"
          />

          <v-btn block depressed color="primary" class="login-button" :loading="signupForm.loading" type="submit">
            Criar conta
            <v-icon right small>mdi-arrow-right</v-icon>
          </v-btn>

          <div class="login-links signup-links">
            <span>
              <v-icon x-small color="#267062">mdi-link-variant</v-icon>
              Vínculo necessário
            </span>
            <button type="button" @click="setMode('login')">Já tenho conta</button>
          </div>
        </v-form>
      </div>
    </section>
  </main>
</template>

<script>
import axios from "axios";
import * as jwt from "jwt-decode";

export default {
  name: "Login",

  data: () => ({
    mode: "login",
    loginForm: {
      validForm: true,
      showPassword: false,
      loading: false,
      user: {
        phone: "",
        password: "",
      },
    },
    signupForm: {
      validForm: true,
      showPassword: false,
      showConfirmPassword: false,
      loading: false,
      user: {
        name: "",
        phone: "",
        email: "",
        password: "",
        passwordConfirmation: "",
      },
    },
  }),

  mounted() {
    const phone = this.$route.query.phone || this.$route.query.celular;
    if (phone) {
      this.loginForm.user.phone = this.formatPhone(phone);
      this.signupForm.user.phone = this.formatPhone(phone);
    }
  },

  computed: {
    isSignup() {
      return this.mode === "signup";
    },
  },

  methods: {
    setMode(mode) {
      this.mode = mode;
      this.$nextTick(() => {
        const form = mode === "login" ? this.$refs.form : this.$refs.signupFormRef;
        if (form && form.resetValidation) form.resetValidation();
      });
    },

    normalizePhone(value) {
      return String(value || "").replace(/\D/g, "");
    },

    formatPhone(value) {
      const digits = this.normalizePhone(value).slice(0, 11);

      if (digits.length <= 2) return digits;
      if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;

      return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    },

    minPassword(value) {
      return String(value || "").length >= 6 || "Senha deve possuir pelo menos 6 caracteres";
    },

    samePassword(value) {
      return value === this.signupForm.user.password || "As senhas nao conferem";
    },

    extractError(error, fallback = "Nao foi possivel concluir a operacao.") {
      if (error && error.response && error.response.data && error.response.data.content && error.response.data.content.error) {
        return error.response.data.content.error.message || fallback;
      }

      if (error && error.content && error.content.error && error.content.error.message) {
        return error.content.error.message;
      }

      return fallback;
    },

    async login() {
      if (!this.$refs.form.validate()) return;

      const data = {
        username: this.normalizePhone(this.loginForm.user.phone),
        password: this.loginForm.user.password,
        type: 4,
      };

      this.loginForm.loading = true;

      try {
        const result = await axios.post("/sessions", data);

        if (!result.data.content.token) throw new Error();

        localStorage.setItem("token", JSON.stringify(result.data.content));

        const dataUser = jwt(result.data.content.token);

        this.$root.user = dataUser;
        localStorage.setItem("user", JSON.stringify(dataUser));
        localStorage.setItem("profilePermissions", JSON.stringify(["*"]));
        localStorage.removeItem("associationProfile");

        this.$router.push("/perfis");
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
        this.loginForm.user.password = "";
      } finally {
        this.loginForm.loading = false;
      }
    },

    async signup() {
      if (!this.$refs.signupFormRef.validate()) return;

      this.signupForm.loading = true;

      try {
        await axios.post("/sessions/register-resident", {
          name: this.signupForm.user.name,
          phone: this.normalizePhone(this.signupForm.user.phone),
          email: this.signupForm.user.email,
          password: this.signupForm.user.password,
        });

        this.loginForm.user.phone = this.signupForm.user.phone;
        this.loginForm.user.password = this.signupForm.user.password;

        this.$dialog.notify.success("Conta criada com sucesso", {
          position: "top-right",
          timeout: 4000,
        });

        this.setMode("login");
      } catch (error) {
        this.$dialog.notify.error(this.extractError(error, "Nao foi possivel criar a conta."), {
          position: "top-right",
          timeout: 5000,
        });
      } finally {
        this.signupForm.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.login-screen {
  align-items: center;
  background: #f4f7f5;
  color: #111827;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  overflow: auto;
  padding: 20px;
  position: relative;
}

.login-shell {
  background: #ffffff;
  border: 1px solid #e6ece8;
  border-radius: 28px;
  box-shadow: 0 24px 68px rgba(17, 24, 39, 0.08);
  display: flex;
  flex-direction: column;
  margin: auto;
  min-height: min(720px, calc(100vh - 40px));
  overflow: hidden;
  position: relative;
  width: min(100%, 390px);
}

.login-header {
  background: transparent;
  color: #111827;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 238px;
  overflow: hidden;
  padding: 26px 26px 28px;
  position: relative;
}

.brand-row {
  align-items: center;
  display: flex;
  gap: 14px;
  position: relative;
  z-index: 1;

  h1 {
    font-size: 22px;
    font-weight: 900;
    line-height: 1.05;
    margin: 0;
  }

  p {
    color: #6b756f;
    font-size: 13px;
    margin: 3px 0 0;
  }
}

.brand-mark {
  align-items: center;
  background: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.26);
  border-radius: 13px;
  display: inline-flex;
  height: 50px;
  justify-content: center;
  overflow: hidden;
  position: relative;
  width: 50px;
  z-index: 1;

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
}

.welcome-copy {
  position: relative;
  z-index: 1;

  strong {
    display: block;
    font-size: 30px;
    font-weight: 850;
    line-height: 1.02;
    max-width: 270px;
  }

  p {
    max-width: 300px;
    margin: 10px 0 0;
    color: #6b756f;
    font-size: 13px;
    line-height: 1.45;
  }
}

.login-panel {
  background: transparent;
  border-radius: 24px 24px 0 0;
  flex: 1;
  margin-top: -12px;
  padding: 20px 26px 26px;
  position: relative;
  z-index: 2;

  h2 {
    margin: 0 0 18px;
    color: #111827;
    font-size: 22px;
    line-height: 1;
  }
}

.mode-switch {
  background: #f2f7f4;
  border: 1px solid #dfe9e3;
  border-radius: 14px;
  display: grid;
  gap: 4px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-bottom: 18px;
  padding: 4px;

  button {
    background: transparent;
    border: 0;
    border-radius: 10px;
    color: #68756e;
    cursor: pointer;
    font-size: 13px;
    font-weight: 850;
    height: 38px;
    letter-spacing: 0;
  }

  button.active {
    background: #ffffff;
    box-shadow: 0 8px 18px rgba(17, 24, 39, 0.08);
    color: #057a3d;
  }
}

.field-label {
  align-items: center;
  color: #267062;
  display: flex;
  font-size: 13px;
  font-weight: 800;
  gap: 7px;
  margin: 0 0 8px;
}

.login-field {
  margin-bottom: 18px;

  ::v-deep .v-input__slot {
    background: #fbfdfc !important;
    border-radius: 13px;
    min-height: 52px !important;
  }

  ::v-deep input {
    color: #111827;
    font-size: 16px;
    font-weight: 650;
  }

  ::v-deep fieldset {
    border-color: #d8e3de;
  }
}

.login-button {
  border-radius: 14px;
  font-size: 16px;
  font-weight: 850;
  height: 52px !important;
  letter-spacing: 0;
  margin-top: 14px;
  text-transform: none;
}

.social-divider {
  margin: 22px 0 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #8a948e;
  font-size: 12px;
  font-weight: 700;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #e7ece8;
  }
}

.social-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.social-button {
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #111827;
  background: #ffffff;
  border: 1px solid #dfe6e1;
  border-radius: 14px;
  font-size: 14px;
  font-weight: 800;

  &:disabled {
    opacity: 0.52;
  }
}

.login-links {
  align-items: center;
  color: #267062;
  display: flex;
  font-size: 12px;
  font-weight: 800;
  justify-content: space-between;
  margin-top: 26px;

  span {
    align-items: center;
    display: inline-flex;
    gap: 5px;
  }

  button {
    background: transparent;
    border: 0;
    color: #267062;
    cursor: pointer;
    font: inherit;
    padding: 0;
  }
}

.signup-links {
  margin-top: 18px;
}

@media (min-width: 768px) {
  .login-screen {
    padding: 40px;
  }

  .login-shell {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(360px, 430px);
    min-height: min(680px, calc(100vh - 80px));
    width: min(100%, 1040px);
  }

  .login-header {
    min-height: auto;
    padding: 56px 52px;
  }

  .brand-row {
    gap: 16px;

    h1 {
      font-size: 26px;
    }

    p {
      font-size: 14px;
    }
  }

  .brand-mark {
    height: 58px;
    width: 58px;
  }

  .welcome-copy {
    strong {
      font-size: 44px;
      max-width: 430px;
    }

    p {
      font-size: 17px;
      line-height: 1.55;
      max-width: 430px;
    }
  }

  .login-panel {
    border-left: 1px solid #e6ece8;
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 0;
    overflow-y: auto;
    padding: 42px;
  }
}

@media (max-width: 430px) {
  .login-screen {
    padding: 0;
  }

  .login-shell {
    border: 0;
    border-radius: 0;
    box-shadow: none;
    min-height: 100vh;
    width: 100%;
  }

  .login-header {
    min-height: 250px;
    padding-top: max(28px, env(safe-area-inset-top));
  }

  .login-panel {
    border-radius: 24px 24px 0 0;
    margin-top: -10px;
    padding-top: 22px;
  }
}
</style>
